<div class="star-wrapper">
  <mat-icon svgIcon="hf-star" (click)="rate(5)" class="s5" [class.color]="currentStar.value >= 5"></mat-icon>
  <mat-icon svgIcon="hf-star" (click)="rate(4)" class="s4" [class.color]="currentStar.value >= 4"></mat-icon>
  <mat-icon svgIcon="hf-star" (click)="rate(3)" class="s3" [class.color]="currentStar.value >= 3"></mat-icon>
  <mat-icon svgIcon="hf-star" (click)="rate(2)" class="s2" [class.color]="currentStar.value >= 2"></mat-icon>
  <mat-icon svgIcon="hf-star" (click)="rate(1)" class="s1" [class.color]="currentStar.value >= 1"></mat-icon>
</div>
